var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height justify-center align-center",attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"auto"}},[_c('v-progress-circular',_vm._b({attrs:{"indeterminate":""}},'v-progress-circular',{ color: 'primary', ..._vm.$attrs },false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }